// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fgi[data-v-119f4de1]{background-color:white;min-height:60px;margin-bottom:20px;border:solid 1px #ccc;border-radius:5px;width:100%;position:relative}.fgi__text[data-v-119f4de1]{font-size:18px;padding:15px}.fgi__delete-button[data-v-119f4de1]{position:absolute;color:#cf583a;cursor:pointer;top:10px;right:5px;font-size:25px;line-height:25px;display:block;border-radius:50%;width:25px;height:25px;z-index:5}\n", ""]);
// Exports
module.exports = exports;
